module.exports = __webpack_public_path__ + "static/o_nama_2014-1934f95670c683582e87d347f63dfb38.png";